<template>
  <!-- mobile actions bar -->
  <v-card
    flat
    tile
    height="100%"
    class="d-flex flex-column justify-space-around"
  >
    <v-dialog
      v-if="authenticated"
      v-model="buyNow"
      max-width="500px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="flipAsset.allowBuyItNow"
          small
          :disabled="flipAsset.salesState !== 'ForSale' && flipAsset.salesState !== 'SoldOut'"
          width="100%"
          height="50"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="mr-1">mdi-cash-multiple</v-icon>
          <span>Buy Car</span>
        </v-btn>
      </template>
      <BuyItNowForm
        v-on:dialog-close="buyNow = false"
      ></BuyItNowForm>
    </v-dialog>
    <v-btn
      v-else-if="flipAsset.allowBuyItNow"
      @click="bounceBack"
      :disabled="flipAsset.salesState !== 'ForSale' && flipAsset.salesState !== 'SoldOut'"
      small
      width="100%"
      height="50"
    >
      <v-icon class="mr-1">mdi-cash-multiple</v-icon>
      <span>Buy Car</span>
    </v-btn>

    <v-btn
      :href="flipAsset.auctionLink"
      target="_blank"
      :disabled="flipAsset.salesState !== 'InAuction' && flipAsset.salesState !== 'Purchased'"
      small
      width="100%"
      height="50"
    >
      <v-icon class="mr-1">mdi-bullhorn-outline</v-icon>
      <span>Go To Auction</span>
    </v-btn>

    <v-dialog
      v-if="authenticated"
      v-model="buyShares"
      max-width="500px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          :disabled="flipAsset.salesState === 'SoldOut' || flipAsset.salesState === 'Purchased' || flipAsset.salesState === 'InAuction' || flipAsset.salesState === 'Suspended' || flipAsset.salesState === 'PendingPurchase'"
          width="100%"
          height="50"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="mr-1">mdi-finance</v-icon>
          <span>Buy Shares</span>
        </v-btn>
      </template>
      <PurchaseShareForm
          ref="purchaseForm"
        v-on:dialog-close="buyShares = false"
      ></PurchaseShareForm>
    </v-dialog>
    <v-btn
      v-else
      @click="bounceBack"
      small
      :disabled="flipAsset.salesState === 'SoldOut' || flipAsset.salesState === 'Purchased' || flipAsset.salesState === 'InAuction' || flipAsset.salesState === 'Suspended' || flipAsset.salesState === 'PendingPurchase'"
      width="100%"
      height="50"
    >
      <v-icon class="mr-1">mdi-finance</v-icon>
      <span>Buy Shares</span>
    </v-btn>

    <v-dialog
      v-if="isAdmin"
      v-model="adminBuyShares"
      max-width="500px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          :disabled="flipAsset.salesState === 'SoldOut' || flipAsset.salesState === 'Purchased' || flipAsset.salesState === 'InAuction' || flipAsset.salesState === 'Suspended' || flipAsset.salesState === 'PendingPurchase'"
          width="100%"
          height="50"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="mr-1">mdi-shield-account</v-icon>
          <span>Admin Buy Shares</span>
        </v-btn>
      </template>
      <AdminPurchaseShareForm
        v-on:dialog-close="adminBuyShares = false"
      ></AdminPurchaseShareForm>
    </v-dialog>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PurchaseShareForm from './PurchaseShareForm.vue'
  import AdminPurchaseShareForm from './admin/AdminPurchaseShareForm.vue'
  import BuyItNowForm from './BuyItNowForm.vue'

  export default {
    name: 'AssetActions',

    components: {
      PurchaseShareForm,
      AdminPurchaseShareForm,
      BuyItNowForm
    },

    computed: {
      ...mapGetters([
        'authenticated',
        'isAdmin',
        'loginRedirect',
        'flipAsset'
      ])
    },

    data: () => ({
      // Dialog handling.
      buyShares: false,
      adminBuyShares: false,
      buyNow: false
    }),

    watch: {
      buyShares(visible) {
        if (visible) {
          if (this.$refs.purchaseForm) {
            this.$refs.purchaseForm.dialogOpen()
          }
        }
      }
    },

    methods: {
      bounceBack: function() {
        this.$cookies.set('assetBounce', this.flipAsset.id, '', '/')
        window.location.href = this.loginRedirect
      }
    }
  }
</script>
